import React from 'react';

import { FaUser } from 'react-icons/fa';
import './avatar.scss';

export const UserAvatar = () => {
    return (
        <div className="chat__avatar__wrapper">
            <FaUser size={20} />
        </div>
    );
};
